function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 352.471 394.635",
    style: {
      enableBackground: "new 0 0 352.471 394.635"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF4F9"
    },
    d: "M197.09,121.068c0,0-3.012-63.236-11.041-94.688c0,0-4.665-20.559-9.744-21.828h-0.139 c-5.08,1.269-9.744,21.828-9.744,21.828c-7.852,30.752-10.904,91.883-11.036,94.584l0.027,0.104c0,0,0,108.411,0,144.828 c0,36.416,0.554,49.103,4.218,66.477c0.017,0.081,0.031,0.155,0.048,0.236c0.566,1.555,4.349,10.367,17.397,10.367 c12.471,0,15.201-8.051,15.697-10.121c0.034-0.163,0.063-0.316,0.1-0.482c3.663-17.374,4.217-30.061,4.217-66.477 C197.09,229.48,197.09,121.068,197.09,121.068z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#A1B2C1"
    },
    d: "M186.049,26.381c0,0-4.665-20.559-9.744-21.828h-0.139 c-5.08,1.269-9.744,21.828-9.744,21.828c-7.852,30.752-10.904,91.883-11.036,94.584l0.027,0.104c0,0,0,108.411,0,144.828 c0,36.416,0.554,49.103,4.218,66.477c0.017,0.081,0.031,0.155,0.048,0.236c0.566,1.555,4.349,10.367,17.397,10.367 c12.471,0,15.201-8.051,15.697-10.121c0.034-0.163,0.063-0.316,0.1-0.482c3.663-17.374,4.217-30.061,4.217-66.477 c0-36.417,0-144.828,0-144.828S194.078,57.832,186.049,26.381z M186.404,201.501c0,0-4.907-6.134-11.042-6.134 c-1.227,0,0.608,17.905,0.611,26.741c0.003,8.836,2.456,25.398,9.816,30.918c0.614,35.577-0.613,63.18-7.974,67.474 c-7.361,4.293-25.763-101.823-14.722-253.945c0,0,4.907-52.139,12.268-55.206c7.361-3.067,9.201,50.298,9.201,50.298 s-12.881-9.2-14.108,28.217c-1.227,37.417,5.761,86.485,5.334,94.154c-0.427,7.669,10.615,0.922,10.615-6.439V201.501z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M248.354,346.702l-4.033,1.529c2.465,0.849,4.033,1.387,4.033,1.387V346.702z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M108.509,348.141l-4.296-1.629v3.106C104.213,349.618,105.893,349.042,108.509,348.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M212.179,385.618c1.423,3.658,1.626,5.283,5.284,4.064c3.658-1.219,63.406-24.387,63.406-24.387 l-2.439-13.616l-17.684-9.678l-12.394,4.701v2.916c0,0-1.568-0.538-4.033-1.387l-40.208,15.251 C208.016,374.264,211.576,384.067,212.179,385.618z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAF4F9"
    },
    points: "248.354,335.218 248.354,346.702 260.747,342.001  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M104.213,349.618v-3.106l-12.245-4.646l-17.928,9.813l-2.438,13.616 c0,0,59.748,23.168,63.406,24.387c3.658,1.22,3.861-0.405,5.283-4.064c0.607-1.56,4.208-11.476,8.14-22.335l-39.922-15.143 C105.893,349.042,104.213,349.618,104.213,349.618z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAF4F9"
    },
    points: "104.213,335.218 104.119,335.122 104.117,335.218 91.968,341.866 104.213,346.512  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BECCD3"
    },
    d: "M347.772,239.754c-0.001-0.072-0.003-0.15-0.005-0.221c-0.145-6.267-0.582-8.307-4.08-9.618 c-3.498-1.313-108.957-41.182-108.957-41.182l-0.042-0.034l2.627,10.962L347.772,239.754z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A1B2C1"
    },
    points: "234.716,188.813 234.688,188.699 223.439,179.181 223.439,251.186  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M219.731,281.447l-4.768,12.988l3.922,2.982c0,0,15.331-4.211,35.195-9.676v-14.164 L219.731,281.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BECCD3"
    },
    d: "M254.081,273.578v14.164c36.082-9.926,87.125-23.985,88.441-24.455 c2.041-0.729,5.246-1.166,5.246-4.664c0-1.413,0.023-3.785,0.043-6.515L254.081,273.578z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BECCD3"
    },
    d: "M117.865,188.627l-0.125,0.106c0,0-105.46,39.869-108.957,41.182 c-3.498,1.311-3.936,3.352-4.081,9.618c-0.002,0.078-0.003,0.165-0.005,0.246l110.525-40.118L117.865,188.627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A1B2C1"
    },
    d: "M129.098,179.181l-0.066-0.086c-0.001,0.052-0.001,0.086-0.001,0.086l-11.165,9.446l-0.044,0.185 l11.276,62.374V179.181z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BECCD3"
    },
    d: "M4.66,252.093c0.019,2.737,0.042,5.114,0.042,6.53c0,3.498,3.206,3.935,5.246,4.664 c1.317,0.47,52.422,14.547,88.508,24.474v-14.183L4.66,252.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M132.806,281.447l-34.35-7.869v14.183c19.832,5.455,35.129,9.657,35.129,9.657l-0.078,0.065 l0.173-0.065l3.9-2.966L132.806,281.447z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD0000"
    },
    d: "M4.697,239.779c-0.08,3.693-0.064,8.376-0.037,12.314l3.553,0.814v-14.404L4.697,239.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD0000"
    },
    d: "M347.772,239.754l-3.447-1.251v14.403l3.485-0.798 C347.838,248.158,347.853,243.457,347.772,239.754z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC0000"
    },
    d: "M193.071,332.928l-0.598-0.135l0.1-0.485l0.604,0.109 C193.177,332.417,193.15,332.604,193.071,332.928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF4F9"
    },
    d: "M155.413,265.897c0-36.417,0-144.828,0-144.828l-0.027-0.104c-0.003,0.062-0.005,0.104-0.005,0.104 s-6.283-14.756-10.735-14.531c-2.589,0.129-13.01,13.373-14.096,22.491c-1.058,8.886-1.497,48.073-1.519,50.066l0.066,0.086 v72.005l-11.276-62.374l-2.6,10.85L8.213,238.503v14.404l124.593,28.54l4.774,13.005l7.4-5.627h3.316v49.739c0,0,0,0-1.106,0.664 c-1.326-2.21-3.315-3.537-9.947-1.105c-4.96,1.818-20.974,7.346-28.734,10.018l39.922,15.143 c5.285-14.602,11.167-30.91,11.167-30.91s0.026,0.086,0.081,0.236c-0.017-0.081-0.031-0.155-0.048-0.236 C155.967,314.999,155.413,302.313,155.413,265.897z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#A1B2C1"
    },
    d: "M159.631,332.373c-3.664-17.374-4.218-30.061-4.218-66.477 c0-36.417,0-144.828,0-144.828l-0.027-0.104c-0.003,0.062-0.005,0.104-0.005,0.104s-6.283-14.756-10.735-14.531 c-2.589,0.129-13.01,13.373-14.096,22.491c-0.446,3.749-0.782,12.891-1.023,22.357l0.332-0.29c0,0,2.879-26.313,10.278-31.658 c5.756-4.522,7.811,64.551,8.223,111.833c0.412,50.571-10.69,46.049-71.129,34.125c-36.571-7.214-57.885-11.869-69.018-14.422 v1.934l124.593,28.54l4.774,13.005l7.4-5.627h3.316v49.739c0,0,0,0-1.106,0.664c-1.326-2.21-3.315-3.537-9.947-1.105 c-4.96,1.818-20.974,7.346-28.734,10.018l39.922,15.143c5.285-14.602,11.167-30.91,11.167-30.91s0.026,0.086,0.081,0.236 C159.662,332.528,159.647,332.454,159.631,332.373z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF4F9"
    },
    d: "M205.375,339.229c-1.107-0.664-1.107-0.664-1.107-0.664v-49.739h3.316l7.379,5.61l4.768-12.988 l124.594-28.541l0.027-14.373l-107.026-38.86l-2.61-10.86l-11.276,62.373v-72.005c0,0-0.434-41.034-1.52-50.152 c-1.085-9.118-11.506-22.362-14.095-22.491c-4.452-0.225-10.735,14.531-10.735,14.531s0,108.411,0,144.828 c0,36.416-0.554,49.103-4.217,66.477c0,0,5.936,16.457,11.239,31.109l40.208-15.251c-7.655-2.636-23.98-8.27-28.998-10.108 C208.69,335.691,206.701,337.019,205.375,339.229z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#A1B2C1"
    },
    d: "M207.585,288.825l7.379,5.61l4.768-12.988l124.594-28.541l-0.073-1.893 c-11.18,2.561-32.461,7.204-68.847,14.382c-60.439,11.924-71.541,16.446-71.129-34.125c0.411-47.282,2.467-116.355,8.223-111.833 c7.4,5.346,10.279,31.658,10.279,31.658l0.161,0.143c-0.24-9.415-0.575-18.48-1.02-22.21 c-1.085-9.118-11.506-22.362-14.095-22.491c-4.452-0.225-10.735,14.531-10.735,14.531s0,108.411,0,144.828 c0,36.416-0.554,49.103-4.217,66.477c0,0,5.936,16.457,11.239,31.109l40.208-15.251c-7.655-2.636-23.98-8.27-28.998-10.108 c-6.632-2.432-8.621-1.105-9.947,1.105c-1.107-0.664-1.107-0.664-1.107-0.664v-49.739H207.585z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD0000"
    },
    d: "M217.661,139.746c-2.464-0.376,0,63.829,0,95.163c0,31.333,2.965,31.843,5.778,16.276v-72.005 c0,0-0.067-6.388-0.216-14.681l0,0C223.224,164.5,220.125,140.123,217.661,139.746z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD0000"
    },
    d: "M135.275,234.909c0-31.334,2.464-95.539,0-95.163c-2.463,0.377-5.563,24.754-5.563,24.754 l-0.482,0.829c-0.129,7.354-0.192,13.038-0.2,13.766l0.066,0.086V248.8c0.127,0.81,0.259,1.608,0.399,2.386 C132.311,266.752,135.275,266.242,135.275,234.909z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M172.951,217.183h6.044c0.132-0.587,0.246-1.213,0.342-1.873h-6.727 C172.706,215.97,172.819,216.596,172.951,217.183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M179.241,217.489h-6.535l-0.054-0.239c-0.131-0.585-0.247-1.223-0.345-1.896l-0.051-0.351h7.436 l-0.051,0.351c-0.097,0.665-0.213,1.304-0.346,1.896L179.241,217.489z M173.198,216.876h5.55 c0.085-0.402,0.163-0.824,0.232-1.26h-6.014C173.036,216.056,173.114,216.478,173.198,216.876z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M172.61,215.31h6.727c0.087-0.6,0.156-1.227,0.209-1.875H172.4 C172.454,214.083,172.523,214.71,172.61,215.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M179.602,215.616h-7.258l-0.038-0.263c-0.085-0.59-0.157-1.227-0.212-1.894l-0.027-0.332h7.811 l-0.027,0.331c-0.054,0.662-0.125,1.299-0.211,1.895L179.602,215.616z M172.877,215.003h6.193 c0.054-0.404,0.102-0.827,0.141-1.262h-6.476C172.775,214.179,172.823,214.601,172.877,215.003z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M175.974,222.108c0.963,0,1.836-1.163,2.494-3.052h-4.988 C174.137,220.945,175.011,222.108,175.974,222.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M175.974,222.415c-1.08,0-2.042-1.126-2.784-3.258l-0.142-0.407h5.852l-0.142,0.407 C178.015,221.289,177.052,222.415,175.974,222.415z M173.919,219.363c0.604,1.556,1.343,2.439,2.055,2.439 c0.711,0,1.45-0.882,2.055-2.439H173.919z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M173.48,219.057h4.988c0.196-0.564,0.374-1.191,0.527-1.874h-6.044 C173.105,217.866,173.283,218.492,173.48,219.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M178.686,219.363h-5.425l-0.071-0.206c-0.203-0.583-0.384-1.226-0.538-1.907l-0.084-0.374h6.811 l-0.084,0.374c-0.152,0.68-0.333,1.321-0.537,1.907L178.686,219.363z M173.699,218.75h4.549c0.131-0.397,0.252-0.819,0.36-1.261 h-5.269C173.448,217.932,173.568,218.355,173.699,218.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M172.4,213.435h7.145c0.051-0.607,0.087-1.23,0.105-1.873h-7.355 C172.313,212.204,172.351,212.827,172.4,213.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M179.828,213.741h-7.71l-0.023-0.281c-0.054-0.662-0.089-1.28-0.105-1.89l-0.009-0.315h7.987 l-0.009,0.315c-0.018,0.625-0.054,1.262-0.106,1.89L179.828,213.741z M172.684,213.128h6.579c0.032-0.42,0.056-0.842,0.071-1.26 h-6.721C172.629,212.296,172.653,212.716,172.684,213.128z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M178.521,202.192h-5.097c-0.189,0.568-0.362,1.191-0.511,1.874h6.118 C178.885,203.384,178.712,202.761,178.521,202.192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M179.412,204.373h-6.878l0.08-0.372c0.145-0.663,0.319-1.304,0.52-1.905l0.07-0.21h5.539 l0.07,0.209c0.201,0.602,0.376,1.243,0.52,1.907L179.412,204.373z M173.298,203.76h5.35c-0.104-0.435-0.22-0.856-0.349-1.261 h-4.652C173.518,202.903,173.402,203.326,173.298,203.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M172.279,210.548c0,0.342,0.008,0.679,0.017,1.014h7.355c0.009-0.335,0.016-0.672,0.016-1.014 c0-0.291-0.007-0.576-0.014-0.859h-7.36C172.287,209.972,172.279,210.257,172.279,210.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M179.95,211.868h-7.953l-0.008-0.299c-0.009-0.337-0.017-0.677-0.017-1.021 c0-0.237,0.005-0.47,0.01-0.701l0.01-0.465h7.96l0.007,0.299c0.007,0.286,0.014,0.573,0.014,0.867 c0,0.345-0.007,0.685-0.016,1.021L179.95,211.868z M172.595,211.255h6.757c0.005-0.234,0.008-0.47,0.008-0.707 c0-0.186-0.003-0.37-0.007-0.553h-6.76c-0.004,0.183-0.007,0.366-0.007,0.553C172.586,210.785,172.59,211.02,172.595,211.255z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M172.914,204.066c-0.127,0.588-0.236,1.216-0.328,1.874h6.774 c-0.092-0.658-0.201-1.286-0.328-1.874H172.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M179.713,206.247h-7.48l0.049-0.349c0.094-0.672,0.206-1.311,0.332-1.896l0.052-0.242h6.613 l0.052,0.242c0.126,0.586,0.238,1.225,0.332,1.896L179.713,206.247z M172.94,205.634h6.065 c-0.067-0.439-0.141-0.861-0.223-1.261h-5.62C173.081,204.773,173.007,205.194,172.94,205.634z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M175.974,198.987c-0.989,0-1.886,1.225-2.549,3.205h5.097 C177.858,200.212,176.963,198.987,175.974,198.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M178.948,202.499h-5.949l0.135-0.404c0.748-2.233,1.73-3.414,2.84-3.414 c1.109,0,2.091,1.181,2.839,3.414L178.948,202.499z M173.858,201.886h4.23c-0.615-1.653-1.376-2.592-2.114-2.592 C175.234,199.294,174.473,200.232,173.858,201.886z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M172.388,207.814h7.171c-0.05-0.646-0.115-1.273-0.198-1.873h-6.774 C172.503,206.54,172.438,207.167,172.388,207.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M179.89,208.12h-7.833l0.026-0.331c0.054-0.691,0.12-1.31,0.2-1.891l0.037-0.265h7.309 l0.037,0.265c0.082,0.589,0.149,1.226,0.2,1.892L179.89,208.12z M172.721,207.507h6.505c-0.038-0.437-0.083-0.858-0.134-1.26 h-6.237C172.804,206.643,172.76,207.06,172.721,207.507z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M172.293,209.689h7.36c-0.015-0.642-0.047-1.267-0.095-1.875h-7.171 C172.341,208.422,172.309,209.047,172.293,209.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M179.967,209.995h-7.989l0.008-0.314c0.016-0.646,0.048-1.277,0.096-1.891l0.021-0.283h7.739 l0.022,0.282c0.049,0.623,0.081,1.26,0.096,1.893L179.967,209.995z M172.608,209.382h6.73c-0.013-0.422-0.035-0.845-0.064-1.262 h-6.601C172.645,208.533,172.622,208.954,172.608,209.382z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD0000"
    },
    d: "M176.736,328.374c-10.125,0-15.664-1.581-18.412-2.78c0.385,2.221,0.816,4.458,1.307,6.779 c0.017,0.081,0.031,0.155,0.048,0.236c0.566,1.555,4.349,10.367,17.397,10.367c12.471,0,15.201-8.051,15.697-10.121 c0.034-0.163,0.063-0.316,0.1-0.482c0.457-2.168,0.865-4.263,1.23-6.339C191.046,327.147,185.657,328.374,176.736,328.374z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A1B2C1"
    },
    d: "M201.265,137.572c1.54-18.309,4.896-26.627,7.958-30.334c-0.575-0.434-1.056-0.685-1.397-0.701 c-4.452-0.225-10.735,14.531-10.735,14.531s0,108.411,0,144.828c0,36.416-0.554,49.103-4.217,66.477 c0,0,5.936,16.457,11.239,31.109l4.151-1.574c-9.555-23.2-9.836-38.715-9.836-50.914 C198.428,297.162,198.072,175.52,201.265,137.572z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A1B2C1"
    },
    d: "M159.631,332.373c-3.664-17.374-4.218-30.061-4.218-66.477c0-36.417,0-144.828,0-144.828 l-0.027-0.104c-0.003,0.062-0.005,0.104-0.005,0.104s-6.283-14.756-10.735-14.531c-0.421,0.021-1.052,0.393-1.813,1.033 c3.124,3.56,6.617,11.825,8.198,30.615c3.192,37.947,2.837,159.591,2.837,173.422c0,12.061-0.272,27.362-9.514,50.13l4.076,1.546 c5.285-14.602,11.167-30.91,11.167-30.91s0.026,0.086,0.081,0.236C159.662,332.528,159.647,332.454,159.631,332.373z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M175.749,15.713l-0.274,42.307c0,0-3.817-0.443-6.965,2.703 C168.824,40.894,175.434,4.067,175.749,15.713z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1CCD5"
    },
    d: "M219.824,242.678c0.26-26.682-1.814-90.666,0.518-85.744c1.151,2.43,2.238,10.478,3.045,18.004 c-0.036-2.632-0.09-6.297-0.164-10.438l0,0c0,0-3.099-24.377-5.563-24.754c-2.464-0.376,0,63.829,0,95.163 c0,31.333,2.965,31.843,5.778,16.276v-12.845C221.657,257.735,220.05,255.338,219.824,242.678z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1CCD5"
    },
    d: "M135.275,139.746c-2.463,0.377-5.563,24.754-5.563,24.754l-0.482,0.829 c-0.038,2.198-0.07,4.241-0.098,6.054c1.19-5.923,3.184-15.096,4.518-17.318c1.533-2.555-0.921,66.452-0.921,82.093 c0,12.311-1.71,19.868-3.634,10.419v2.224c0.127,0.81,0.259,1.608,0.399,2.386c2.814,15.566,5.778,15.057,5.778-16.276 C135.275,203.575,137.739,139.37,135.275,139.746z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1CCD5"
    },
    d: "M185.492,327.908c-0.532,4.064-2.095,10.729-6.654,15.007c10.966-0.721,13.465-8.091,13.936-10.06 c0.034-0.163,0.063-0.316,0.1-0.482c0.457-2.168,0.865-4.263,1.23-6.339C192.217,326.721,189.438,327.45,185.492,327.908z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M173.379,329.016c0,0-0.92,10.457,2.514,13.355c-5.58-1.287-9.229-4.614-9.657-14.058 C169.55,329.016,173.379,329.016,173.379,329.016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M172.202,329.735c0,0-0.101,8.681,2.58,11.82c-4.364-2.297-5.03-10.365-5.03-11.974 C170.824,329.889,172.202,329.735,172.202,329.735z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#7A8C99"
    },
    d: "M211.239,360.417c-1.213-2.843-2.331-5.828-2.771-8.902 c-0.29-2.032-0.416-4.419,0.715-6.245c2.072-3.347,6.244-3.341,9.705-2.617c5.507,1.152,10.707,3.689,15.674,6.254 c1.101,0.568,2.192,1.172,3.283,1.781l6.476-2.456c-7.655-2.636-23.98-8.27-28.998-10.108c-6.632-2.432-8.621-1.105-9.947,1.105 c-1.107-0.664-1.107-0.664-1.107-0.664v-49.739h3.316l7.379,5.61l4.768-12.988l124.594-28.541l-0.036-0.923 c-15.027,3.706-52.051,12.647-79.276,17.638c-36.225,6.641-63.091,17.207-63.996,1.51c-1.344-23.284-3.571-73.31-3.571-73.31 l-0.355-0.651v68.727c0,36.416-0.554,49.103-4.217,66.477c0,0,5.936,16.457,11.239,31.109l7.266-2.756 C211.333,360.623,211.284,360.521,211.239,360.417z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#7A8C99"
    },
    d: "M155.271,265.897V197.17l-0.355,0.651c0,0-2.228,50.025-3.571,73.31 c-0.906,15.697-27.771,5.131-63.996-1.51c-27.226-4.99-64.249-13.932-79.277-17.638l-0.035,0.923l124.593,28.541l4.882,13.067 l7.467-5.631l3.114-0.059v49.739c0,0,0,0-1.105,0.664c-1.326-2.209-3.313-3.536-9.938-1.109 c-9.614,3.521-19.401,6.555-28.985,10.161c2.104,0.811,5.61,2.948,7.748,2.972c3.893,0.041,7.987-3.806,11.875-5.33 c3.33-1.306,12.96-4.908,15.653-1.209c2.428,3.334-2.479,12.261-4.037,15.465c2.978,0.958,5.993,2.085,8.834,3.375 c2.7-6.598,4.939-13.415,7.36-20.12c0.817-2.264,4.504-8.632,3.992-11.06C155.824,314.999,155.271,302.313,155.271,265.897z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD0000"
    },
    d: "M104.213,349.618c0,0,26.397-9.064,33.03-11.495c6.632-2.432,8.621-1.105,9.947,1.105 c1.106-0.664,1.106-0.664,1.106-0.664v-49.739h-3.316l-11.301,8.593l-0.173,0.065l-29.186,24.524l-0.202,13.114l0.094,0.096 V349.618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD0000"
    },
    d: "M204.268,288.825v49.739c0,0,0,0,1.107,0.664c1.326-2.21,3.315-3.537,9.947-1.105 c6.633,2.432,33.031,11.495,33.031,11.495v-14.4l-0.204-13.21l-29.264-24.59l-11.301-8.593H204.268z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1CCD5"
    },
    d: "M207.889,316.517c0-9.273,0-20.886,0-27.461l-0.304-0.23h-3.316v49.739c0,0,0,0,1.107,0.664 c1.326-2.21,3.315-3.537,9.947-1.105c6.633,2.432,33.031,11.495,33.031,11.495v-5.728 C225.367,334.002,207.889,328.864,207.889,316.517z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1CCD5"
    },
    d: "M144.98,288.825l-0.297,0.225c0,6.575,0,18.191,0,27.467c0,12.349-17.481,17.486-40.471,27.377 v5.725c0,0,26.397-9.064,33.03-11.495c6.632-2.432,8.621-1.105,9.947,1.105c1.106-0.664,1.106-0.664,1.106-0.664v-49.739H144.98 z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    points: "209.718,292.133 246.65,322.7 246.65,333.647 241.397,328.268  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    points: "142.834,292.133 105.901,322.7 105.901,333.647 111.154,328.268  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "221.785,303.227 245.535,323.052 245.535,326.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "131.198,303.227 107.448,323.052 107.448,326.78  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D1D1B"
    },
    points: "234.716,188.813 237.402,199.654 237.352,199.6 264.997,209.531 292.624,219.51  320.211,229.596 334.002,234.648 347.772,239.754 333.932,234.841 320.111,229.871 292.475,219.917 264.879,209.855  237.3,199.746 237.26,199.732 237.251,199.691  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D1D1B"
    },
    points: "117.821,188.812 115.297,199.679 115.288,199.72 115.248,199.734 87.649,209.853  60.034,219.924 32.378,229.887 18.548,234.861 4.697,239.779 18.478,234.668 32.278,229.612 59.885,219.517 87.532,209.528  115.195,199.588 115.146,199.643  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D1D1B"
    },
    points: "8.036,252.906 23.633,256.376 39.217,259.9 70.38,266.968 101.52,274.141  132.648,281.361 132.695,281.372 132.711,281.416 137.58,294.452 132.546,281.479 132.609,281.533 101.441,274.483  70.285,267.386 39.152,260.183 23.588,256.572  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D1D1B"
    },
    points: "214.964,294.436 219.651,281.418 219.667,281.375 219.712,281.364 251.624,273.955  283.546,266.594 315.493,259.34 331.469,255.722 347.457,252.16 331.514,255.92 315.558,259.624 283.642,267.014  251.702,274.296 219.751,281.53 219.811,281.477  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D1D1B"
    },
    d: "M98.456,273.578c0,0,0.073,0.887,0.129,2.216c0.019,0.665,0.062,1.44,0.07,2.271 c0.01,0.831,0.02,1.718,0.031,2.605c-0.01,0.886-0.021,1.772-0.03,2.603c-0.008,0.831-0.051,1.606-0.07,2.272 c-0.055,1.329-0.129,2.216-0.129,2.216s-0.074-0.887-0.129-2.216c-0.019-0.665-0.063-1.441-0.07-2.272 c-0.009-0.831-0.02-1.718-0.03-2.603c0.011-0.887,0.021-1.773,0.031-2.605c0.009-0.831,0.051-1.606,0.07-2.271 C98.383,274.465,98.456,273.578,98.456,273.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D1D1B"
    },
    d: "M254.081,273.578c0,0,0.073,0.885,0.129,2.213c0.019,0.664,0.062,1.438,0.07,2.268 c0.01,0.83,0.02,1.716,0.031,2.601c-0.011,0.885-0.021,1.771-0.03,2.601c-0.008,0.83-0.051,1.604-0.07,2.268 c-0.055,1.328-0.129,2.213-0.129,2.213s-0.074-0.885-0.129-2.213c-0.019-0.664-0.063-1.438-0.07-2.268 c-0.009-0.83-0.02-1.716-0.03-2.601c0.011-0.885,0.021-1.77,0.031-2.601c0.009-0.83,0.051-1.604,0.07-2.268 C254.008,274.463,254.081,273.578,254.081,273.578z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1CCD5"
    },
    d: "M175.789,61.238v122.779l47.418,27.707v-48.123c-0.23-12.629-0.645-29.181-1.287-34.573 c-1.085-9.118-11.506-22.362-14.095-22.491c-4.452-0.225-10.735,14.531-10.735,14.531s-0.256-5.359-0.814-13.725 c-0.02,0.035-0.038,0.068-0.058,0.104C192.946,61.646,175.789,61.238,175.789,61.238z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M171.069,118.079c0,0-1.841,128.813,3.68,181.565C163.095,251.8,163.708,127.894,171.069,118.079z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M191.328,95.9L191.328,95.9c0.006-0.396,0.013-0.792,0.013-1.191 c0-19.22-6.962-34.801-15.552-34.801c-8.589,0-15.551,15.581-15.551,34.801c0,0.399,0.007,0.795,0.013,1.191h-0.013 c0,0,0.006,0.113,0.017,0.314c0.041,2.172,0.174,4.291,0.385,6.342c1.336,20.518,6.066,81.461,15.149,81.461 c9.036,0,13.756-60.314,15.117-81.143c0.241-2.246,0.385-4.576,0.421-6.969C191.328,95.906,191.328,95.9,191.328,95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M175.789,184.324c-9.146,0-13.855-57.169-15.456-81.748c-0.215-2.091-0.345-4.233-0.385-6.355 l-0.033-0.627h0.024c-0.004-0.294-0.008-0.589-0.008-0.885c0-19.358,7.114-35.107,15.857-35.107 c8.745,0,15.858,15.749,15.858,35.107c0,0.352-0.005,0.699-0.01,1.048l-0.008,0.45c-0.043,2.265-0.183,4.517-0.418,6.701 C189.612,127.378,184.906,184.324,175.789,184.324z M160.561,96.207c0.04,2.113,0.169,4.235,0.383,6.318 c1.241,19.054,5.976,81.186,14.844,81.186c8.839,0,13.571-61.888,14.811-80.855c0.244-2.273,0.385-4.608,0.42-6.954l0.005-0.302 c0.004-0.296,0.008-0.592,0.008-0.891c0-19.021-6.839-34.494-15.245-34.494c-8.406,0-15.244,15.474-15.244,34.494 c0,0.348,0.005,0.693,0.01,1.038L160.561,96.207L160.561,96.207z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M191.321,96.143c-14.48-7.49-26.593-2.653-31.07-0.27c0,0.01,0,0.019,0,0.027h-0.013 c0,0,0.006,0.113,0.017,0.314c0.041,2.172,0.174,4.291,0.385,6.342c0.323,4.963,0.846,12.297,1.58,20.557 c5.216,2.303,15.28,5.061,27.155-0.276c0.704-7.974,1.211-15.061,1.531-19.962C191.14,100.703,191.279,98.452,191.321,96.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M175.447,126.218C175.447,126.218,175.447,126.218,175.447,126.218 c-5.748,0-10.433-1.535-13.352-2.824l-0.166-0.073l-0.016-0.18c-0.746-8.387-1.271-15.812-1.581-20.564 c-0.215-2.091-0.345-4.233-0.385-6.355l-0.033-0.627h0.208c2.661-1.414,8.173-3.775,15.313-3.775 c5.437,0,10.829,1.363,16.026,4.052l0.169,0.088l-0.003,0.19c-0.042,2.301-0.182,4.575-0.417,6.76 c-0.3,4.589-0.81,11.789-1.531,19.956l-0.016,0.179l-0.164,0.073C184.922,125.175,180.193,126.218,175.447,126.218z  M162.509,122.905c2.874,1.249,7.404,2.699,12.937,2.699c0,0,0,0,0.001,0c4.602,0,9.189-1,13.638-2.974 c0.712-8.087,1.216-15.211,1.515-19.775c0.228-2.118,0.365-4.31,0.411-6.527c-5.057-2.586-10.295-3.896-15.574-3.896 c-6.878,0-12.216,2.232-14.879,3.626l0.003,0.141c0.04,2.116,0.169,4.241,0.384,6.327 C161.253,107.251,161.772,114.6,162.509,122.905z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M163.355,94.445c-1.257,0.498-2.304,1.002-3.104,1.428c0,0.01,0,0.019,0,0.027h-0.013 c0,0,0.006,0.113,0.017,0.314c0.041,2.172,0.174,4.291,0.385,6.342c0.323,4.963,0.846,12.297,1.58,20.557 c1.179,0.521,2.607,1.064,4.246,1.531C164.145,114.787,164.188,104.539,163.355,94.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M188.556,94.851c-0.122,5.544-0.637,11.073-1.172,16.593c-0.332,3.421-0.635,6.837-0.888,10.264 c-0.059,0.785-0.125,1.57-0.211,2.352c1.015-0.35,2.045-0.752,3.09-1.222c0.704-7.974,1.211-15.061,1.531-19.962 c0.233-2.172,0.373-4.423,0.415-6.732C190.389,95.66,189.467,95.234,188.556,94.851z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#51524A"
    },
    d: "M191.315,96.361c0.003-0.152,0.01-0.302,0.012-0.455 c0.001,0,0.001-0.006,0.001-0.006c0.006-0.396,0.013-0.792,0.013-1.191c0-12.424-2.911-23.32-7.289-29.478 c-0.053,0.063-0.061,0.126-0.003,0.182c0.988,0.989,8.504,21.953-8.702,21.953c-15.942,0-9.136-19.011-8.049-21.807 c-4.249,6.212-7.06,16.943-7.06,29.149c0,0.399,0.007,0.795,0.013,1.191h-0.013c0,0,0.001,0.021,0.003,0.055 C163.938,94.173,177.625,88.618,191.315,96.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#51524A"
    },
    d: "M172.713,174.98c-5.538-17.266-7.929-42.346-6.347-50.256 c-1.891-0.591-2.48-1.045-4.15-1.652c2.299,25.889,6.684,60.945,13.573,60.945c6.964,0,11.364-35.825,13.64-61.789 c-1.251,0.788-0.596,0.885-3.266,1.863C188.338,141.299,178.233,192.191,172.713,174.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M183.452,98.279L183.452,98.279c0.003-0.195,0.006-0.391,0.006-0.587 c0-9.479-3.433-17.162-7.669-17.162c-4.235,0-7.669,7.684-7.669,17.162c0,0.196,0.003,0.392,0.007,0.587h-0.007 c0,0,0.003,0.057,0.008,0.156c0.021,1.07,0.086,2.115,0.19,3.127c0.658,10.119,2.991,40.174,7.471,40.174 c4.456,0,6.784-29.744,7.455-40.016c0.119-1.108,0.189-2.258,0.208-3.438V98.279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M175.789,141.888c-4.512,0-6.833-28.193-7.622-40.315c-0.106-1.027-0.171-2.084-0.191-3.134 l-0.016-0.311h0.012c-0.002-0.145-0.004-0.29-0.004-0.436c0-9.547,3.508-17.313,7.82-17.313s7.82,7.767,7.82,17.313 c0,0.197-0.003,0.394-0.006,0.589c-0.019,1.177-0.089,2.338-0.209,3.456C182.606,113.805,180.287,141.888,175.789,141.888z  M168.279,98.431c0.021,1.045,0.084,2.092,0.19,3.116c0.336,5.171,1.082,15.14,2.302,23.876 c1.865,13.358,3.758,16.162,5.019,16.162c1.254,0,3.14-2.78,4.997-16.025c1.22-8.701,1.969-18.677,2.307-23.849 c0.12-1.115,0.189-2.267,0.208-3.43c0.003-0.199,0.006-0.394,0.006-0.589c0-9.38-3.372-17.011-7.518-17.011 c-4.146,0-7.518,7.631-7.518,17.011c0,0.195,0.003,0.39,0.007,0.584l0.003,0.154H168.279z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M175.789,80.53c-4.235,0-7.669,7.684-7.669,17.162c0,0.196,0.003,0.392,0.007,0.587h-0.007 c0,0,0.003,0.057,0.008,0.156c0.021,1.07,0.086,2.115,0.19,3.127c0.658,10.119,2.991,40.174,7.471,40.174 c4.456,0,6.784-29.744,7.455-40.016c0.119-1.108,0.189-2.258,0.208-3.438v-0.004c0.003-0.195,0.006-0.391,0.006-0.587 C183.458,88.214,180.025,80.53,175.789,80.53z M182.14,100.482v0.002c-0.016,0.979-0.074,1.931-0.173,2.849 c-0.557,8.511-2.485,33.159-6.178,33.159c-3.712,0-5.645-24.904-6.19-33.289c-0.087-0.839-0.141-1.704-0.157-2.592 c-0.005-0.082-0.007-0.129-0.007-0.129h0.005c-0.003-0.162-0.005-0.324-0.005-0.486c0-7.855,2.845-14.223,6.355-14.223 c3.511,0,6.355,6.367,6.355,14.223C182.145,100.158,182.142,100.32,182.14,100.482z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#51524A"
    },
    d: "M174.605,86.074c0,0,5.067,0.281,4.504,16.471 c-0.563,16.188-3.319,33.947-3.319,33.947s3.038-2.838,4.305-22.827C181.36,93.676,180.798,85.512,174.605,86.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M173.76,88.275c0,0-0.141,27.873,0.703,43.499C174.463,134.027,168.128,100.101,173.76,88.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#51524A"
    },
    d: "M180.679,62.26c0,0,2.71,10.956-1.992,19.339c0.81,0.673,0.867,0.7,0.867,0.7 s6.843-3.918,4.495-16.886L180.679,62.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M171.793,61.551c0,0-2.702,8.703,1.915,19.568c-0.679,0.271-1.507,1.211-1.507,1.211 s-7.225-2.575-4.903-16.771C167.298,65.56,169.484,62.909,171.793,61.551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#51524A"
    },
    d: "M181.91,125.506c0,0-0.582,33.83-6.416,50.551c5.639-8.75,8.944-39.664,9.139-51.328 C183.271,125.506,181.91,125.506,181.91,125.506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M170.039,127.271c0,0-0.552,30.988,3.726,44.598C174.542,175.564,164.952,155.777,170.039,127.271 z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M144.249,361.697l-10.392,27.571c0.547,0.201,0.942,0.345,1.15,0.413 c3.658,1.22,3.861-0.405,5.283-4.064c0.607-1.56,4.208-11.476,8.14-22.335L144.249,361.697z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51524A"
    },
    d: "M204.112,363.483c3.903,10.781,7.464,20.585,8.066,22.136c1.423,3.658,1.626,5.283,5.284,4.064 c0.241-0.08,0.73-0.257,1.423-0.515l-10.635-27.254L204.112,363.483z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#51524A"
    },
    points: "98.265,346.409 74.89,363.941 76.059,353.422 91.837,344.071  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#51524A"
    },
    points: "254.819,346.409 278.193,363.941 277.025,353.422 261.247,344.071  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C1CCD5"
    },
    points: "343.465,261.222 218.433,295.918 220.403,290.006 343.465,259.232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C1CCD5"
    },
    points: "7.832,261.222 132.865,295.918 130.893,290.006 7.832,259.232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#CFD0D9"
    },
    points: "221.569,284 221.806,282.579 343.353,254.384  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#CFD0D9"
    },
    points: "129.892,284 129.655,282.579 8.108,254.384  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BECCD3"
    },
    d: "M347.719,237.962c-15.53-5.869-85.228-32.244-97.931-37.688c-8.05-3.45-11.442-7.676-12.87-10.714 c-1.415-0.535-2.188-0.827-2.188-0.827l-0.042-0.034l2.627,10.962l110.457,40.093c-0.001-0.072-0.003-0.15-0.005-0.221 C347.755,238.972,347.738,238.457,347.719,237.962z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BECCD3"
    },
    d: "M117.74,188.733c0,0-1.009,0.382-2.824,1.067c-1.492,3.019-4.91,7.113-12.752,10.474 c-12.563,5.385-80.89,31.246-97.404,37.488c-0.023,0.552-0.043,1.134-0.058,1.771c-0.002,0.078-0.003,0.165-0.005,0.246 l110.525-40.118l2.643-11.034L117.74,188.733z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M343.929,233.077l-99.622-38.77C244.307,194.307,315.685,218.441,343.929,233.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M8.179,233.077l99.622-38.77C107.801,194.307,36.423,218.441,8.179,233.077z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "228.104,241.985 237.918,206.408 338.515,242.388 338.515,243.212 241.599,224.196  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "123.225,241.985 113.41,206.408 12.813,242.388 12.813,243.212 109.729,224.196  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M175.789,184.018c0.427-7.669-6.561-56.737-5.334-94.154c1.228-37.417,14.108-28.217,14.108-28.217 s-1.84-53.365-9.201-50.298c-7.36,3.067-12.268,55.206-12.268,55.206c-11.041,152.122,7.36,258.238,14.722,253.945 c7.36-4.294,8.588-31.896,7.974-67.474c-7.36-5.52-9.813-22.082-9.816-30.918c-0.003-8.836-1.838-26.741-0.611-26.741 c6.135,0,11.042,6.134,11.042,6.134v-23.923C186.404,184.939,175.362,191.687,175.789,184.018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#7A8C99"
    },
    d: "M160.309,62.791l-0.064-0.034c-3.344,27.813-4.771,56.381-4.859,58.208l0.027,0.104 c0,0,0,108.411,0,144.828c0,36.416,0.554,49.103,4.218,66.477c0.017,0.081,0.031,0.155,0.048,0.236 c0.435,1.194,2.774,6.67,9.751,9.145c-4.041-11.693-10.188-34.65-11.238-68.268C155.016,175.02,160.309,62.791,160.309,62.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#7A8C99"
    },
    d: "M192.072,63.32c0,0,4.235,79.407,2.117,177.872 c-0.48,49.041-4.455,85.853-10.732,100.923c7.089-2.13,8.92-7.604,9.316-9.26c0.034-0.163,0.063-0.316,0.1-0.482 c3.663-17.374,4.217-30.061,4.217-66.477c0-36.417,0-144.828,0-144.828s-1.395-29.285-4.817-57.91L192.072,63.32z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M221.633,169.739c0,0,1.039,51.674,0.779,74.785C222.152,251.017,225.268,192.85,221.633,169.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M131.039,169.739c0,0-1.039,51.674-0.779,74.785C130.52,251.017,127.403,192.85,131.039,169.739z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.ba261d6156e7198f8f3bd1994232965c.svg";
export { ForwardRef as ReactComponent };